import { Component, Input, OnInit } from '@angular/core';
import { Filter, DisplayOptions } from '../models/filter-models';
import { Rarity } from "../models/enums";
import { BaseTypeTier } from "../models/enums";
import { FormsModule } from '@angular/forms';
import { FilterService } from '../services/filter.service';
import { OtherItemFiltersComponent } from './other-item-filters/other-item-filters.component';
import { RemainingGearFiltersComponent } from './remaining-equipment-filters/remaining-equipment-filters.component';
import { SalvagingGearFiltersPoe2Component } from './salvaging-gear-filters-poe2/salvaging-gear-filters-poe2.component';
import { InfluencedGearFiltersPoe1Component } from './influenced-gear-filters-poe1/influenced-gear-filters-poe1.component';
import { logEvent } from '../app.config';
import { UnidentifiedEquipmentFiltersPoe2Component } from './unidentified-equipment-filters-poe2/unidentified-equipment-filters-poe2.component';
import { DEFAULT_FILTER_NAME } from '../../game';
import { LevelingFiltersComponent } from './leveling-filters/leveling-filters.component';
import { VendorRecipeFiltersPoe1Component } from './vendor-recipe-filters-poe1/vendor-recipe-filters-poe1.component';
import { GemFiltersPoe1 } from './gem-filters-poe1/gem-filters-poe1';
import { BaseComponent } from '../common/base.component';
import { TutorialSectionHider, TutorialStepComponent } from '../common/tutorial-step/tutorial-step.component';
import { DynamicContentComponent } from '../common/dynamic-content/dynamic-content.component';
import { ActiveRules, ActiveSpecialRules } from '../services/filter-generator.service';
import { InfluencedJewelleryFiltersPoe1Component } from './influenced-jewellery-filters-poe1/influenced-jewellery-filters-poe1.component';
import { UniqueFiltersComponent } from "./unique-filters/unique-filters.component";
import { CraftingBaseFiltersPoe1Component } from "./crafting-base-filters-poe1/crafting-base-filters-poe1.component";
import { IdentifiedItemFiltersComponent } from "./identified-item-filters/identified-item-filters.component";
import { MyArmourListComponent } from './my-equipment/my-armour-list/my-armour-list.component';
import { MapFiltersPoe1Component } from './map-filters-poe1/map-filters-poe1.component';
import { CraftingBaseFiltersPoe2Component } from './crafting-base-filters-poe2/crafting-base-filters-poe2.component';
import { MyWeaponsListComponent } from './my-equipment/my-weapons-list/my-weapons-list';
import { MyJewelleryListComponent } from './my-equipment/my-jewellery-list/my-jewellery-list';
import { MyJewelsListComponent } from './my-equipment/my-jewels-list/my-jewels-list.component';
import { CurrencyFiltersComponent } from './currency-filters/currency-filters.component';
import { MyFlasksListComponent } from './my-equipment/my-flasks-list/my-flasks-list.component';
import { SpecialEquipmentFiltersPoe2Component } from './special-equipment-filters-poe2/special-equipment-filters-poe2.component';
import { UserOnboardingService } from '../services/user-onboarding.service';

type TutorialStep = 'intro' | 'filter-structure' | 'filter-output' | 'league-start' | 'my-equipment' | 'my-equipment-highlights' | 'other-equipment' | 'remaining-equipment' | 'currency' | 'uniques' | 'skill-gems' | 'maps' | 'other-items' | 'outro';

@Component({
  selector: 'app-quick-filter-tab',
  templateUrl: './quick-filter-tab.component.html',
  styleUrl: './quick-filter-tab.component.scss',
  imports: [FormsModule,
    CurrencyFiltersComponent,
    GemFiltersPoe1,
    RemainingGearFiltersComponent,
    UnidentifiedEquipmentFiltersPoe2Component,
    SalvagingGearFiltersPoe2Component,
    InfluencedGearFiltersPoe1Component,
    MyWeaponsListComponent,
    MyArmourListComponent,
    MyJewelleryListComponent,
    MyJewelsListComponent,
    InfluencedJewelleryFiltersPoe1Component,
    LevelingFiltersComponent,
    VendorRecipeFiltersPoe1Component,
    TutorialStepComponent,
    TutorialSectionHider,
    DynamicContentComponent,
    MapFiltersPoe1Component,
    UniqueFiltersComponent,
    CraftingBaseFiltersPoe1Component,
    CraftingBaseFiltersPoe2Component,
    IdentifiedItemFiltersComponent,
    OtherItemFiltersComponent,
    MyFlasksListComponent,
    SpecialEquipmentFiltersPoe2Component
  ]
})
export class QuickFilterTabComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;
  @Input({ required: true }) filterResetWarning!: boolean;
  @Input({ required: true }) dynamicWaystoneThresholds!: any;

  showLevelingAndCampaignHelpText = false;
  showRemainingEquipmentHelpText = false;
  showCurrencyHelpText = false;
  showUniquesAndOtherHelpText = false;
  showMyEquipmentHelpText = false;
  showOtherEquipmentHelpText = false;

  specifyTiersMoreInfo = false;
  windowsMoreInfo = false;
  showQuickFiltersMainTabBanner = false;

  get tutorialComplete(): boolean {
    return this.settings.tutorialComplete() || this.settings.tutorialsDismissed();
  }
  currentTutorialStep: TutorialStep = 'intro';
  currentTutorialStepIndex = 0;
  isWelcomeStep = true;
  isFinalStep = false;

  unidentifiedItemTierDisplayOptions = new DisplayOptions();

  Rarity = Rarity;
  BaseTypeTier = BaseTypeTier;
  defaultFilterName = DEFAULT_FILTER_NAME;

  tutorialSteps!: { id: TutorialStep, element: string | null, sectionVisibility: keyof Filter['sectionVisibility'] | null }[];

  totalTutorialSteps = 0;

  backupSectionVisibility = {};
  backupgroupVisibility = {};

  constructor(
    private filterService: FilterService,
    private userOnboarding: UserOnboardingService,
  ) {
    super();
  }

  ngOnInit(): void {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.showQuickFiltersMainTabBanner = this.userOnboarding.shouldShowQuickFiltersMainTabBanner();

    this.tutorialSteps = this.poe1 ? [
      { id: 'intro', element: null, sectionVisibility: null },
      { id: 'filter-structure', element: "league-start", sectionVisibility: 'leagueStart' },
      { id: 'filter-output', element: "filter-output", sectionVisibility: null },
      { id: 'league-start', element: "league-start", sectionVisibility: 'leagueStart' },
      { id: 'my-equipment', element: "my-equipment", sectionVisibility: 'myEquipment' },
      { id: 'my-equipment-highlights', element: "my-equipment", sectionVisibility: 'myEquipment' },
      { id: 'other-equipment', element: "other-equipment", sectionVisibility: 'otherEquipment' },
      { id: 'remaining-equipment', element: "remaining-equipment", sectionVisibility: 'remainingEquipment' },
      { id: 'currency', element: "currency", sectionVisibility: 'currency' },
      { id: 'uniques', element: "uniques", sectionVisibility: 'uniques' },
      { id: 'skill-gems', element: "skill-gems", sectionVisibility: 'other' },
      { id: 'maps', element: "maps", sectionVisibility: 'other' },
      { id: 'other-items', element: "other-items", sectionVisibility: 'other' },
      { id: 'outro', element: "outro", sectionVisibility: null },
    ] : [
      { id: 'intro', element: null, sectionVisibility: null },
      { id: 'filter-structure', element: "league-start", sectionVisibility: 'leagueStart' },
      { id: 'filter-output', element: "league-start", sectionVisibility: null },
      { id: 'league-start', element: "league-start", sectionVisibility: 'leagueStart' },
      { id: 'my-equipment', element: "my-equipment", sectionVisibility: 'myEquipment' },
      { id: 'my-equipment-highlights', element: "my-equipment", sectionVisibility: 'myEquipment' },
      { id: 'other-equipment', element: "other-equipment", sectionVisibility: 'otherEquipment' },
      { id: 'remaining-equipment', element: "remaining-equipment", sectionVisibility: 'remainingEquipment' },
      { id: 'currency', element: "currency", sectionVisibility: 'currency' },
      { id: 'uniques', element: "uniques", sectionVisibility: 'uniques' },
      { id: 'other-items', element: "other-items", sectionVisibility: 'other' },
      { id: 'outro', element: "outro", sectionVisibility: null },
    ];

    this.totalTutorialSteps = this.tutorialSteps.length;

    this.backupSectionVisibility = { ...this.filter.sectionVisibility };
    this.backupgroupVisibility = { ...this.filter.groupVisibility };
  }

  showAllGroups() {
    for (const key in this.filter.groupVisibility) {
      if (this.filter.groupVisibility.hasOwnProperty(key)) {
        (this.filter.groupVisibility as Record<string, boolean>)[key] = true;
      }
    }
  }

  collapseAllSectionsExcept(sectionToKeep: keyof Filter['sectionVisibility'] | null) {
    for (const key in this.filter.sectionVisibility) {
      if (this.filter.sectionVisibility.hasOwnProperty(key)) {
        (this.filter.sectionVisibility as Record<string, boolean>)[key] = false;
      }
    }

    if (!sectionToKeep) {
      this.updateFilter();
      return;
    }

    this.filter.sectionVisibility[sectionToKeep] = true;
    this.updateFilter();
  }

  restoregroupVisibility() {
    for (const key in this.filter.sectionVisibility) {
      if (this.filter.sectionVisibility.hasOwnProperty(key)) {
        (this.filter.sectionVisibility as Record<string, boolean>)[key] = this.backupSectionVisibility[key as keyof typeof this.backupSectionVisibility];
      }
    }
    for (const key in this.filter.groupVisibility) {
      if (this.filter.groupVisibility.hasOwnProperty(key)) {
        (this.filter.groupVisibility as Record<string, boolean>)[key] = this.backupgroupVisibility[key as keyof typeof this.backupgroupVisibility];
      }
    }
    this.updateFilter();
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape' && !this.tutorialComplete) {
      this.dismissTutorial(event, true);
    }
  }

  updateFilter() {
    this.filterService.updateFilter();
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  dismissTutorial(event?: any, escape?: boolean) {
    if (event) event.stopPropagation();
    if (this.currentTutorialStep === 'intro') {
      logEvent('tutorial', escape ? 'skipped_with_escape' : event ? 'skipped_with_button' : 'skipped_with_click_outside', 'quick_filter_tab');
    } else {
      logEvent('tutorial', 'dismissed', 'quick_filter_tab');
    }
    this.settings.dismissTutorials();
    this.restoregroupVisibility();
  }

  dismissOrNextTutorialStep() {
    if (this.currentTutorialStep === 'intro') {
      this.dismissTutorial();
    } else {
      this.nextTutorialStep();
    }
  }

  nextTutorialStep(clickEvent?: any) {
    clickEvent?.stopPropagation();

    if (this.currentTutorialStep === 'intro') {
      logEvent('tutorial', 'started', 'quick_filter_tab');

      this.collapseAllSectionsExcept(null);
      this.showAllGroups();
    }

    this.currentTutorialStepIndex++;

    if (this.currentTutorialStepIndex === this.totalTutorialSteps - 1) {
      this.isFinalStep = true;
    }

    if (this.currentTutorialStepIndex === this.totalTutorialSteps) {
      logEvent('tutorial', 'completed', 'quick_filter_tab');
      this.settings.setTutorialComplete(true);
      this.restoregroupVisibility();
      return;
    } else if (!this.tutorialComplete) {
      this.currentTutorialStep = this.tutorialSteps[this.currentTutorialStepIndex].id;
      const step = this.tutorialSteps[this.currentTutorialStepIndex];
      this.collapseAllSectionsExcept(step.sectionVisibility);
      this.scrollIntoViewIfNeeded();
    }
  }

  previousTutorialStep(clickEvent?: any) {
    clickEvent?.stopPropagation();

    this.currentTutorialStepIndex--;
    this.currentTutorialStep = this.tutorialSteps[this.currentTutorialStepIndex].id;

    // Collapse all sections except the one for this tutorial step
    const step = this.tutorialSteps[this.currentTutorialStepIndex];
    this.collapseAllSectionsExcept(step.sectionVisibility);

    this.scrollIntoViewIfNeeded();
  }

  private scrollIntoViewIfNeeded() {
    const step = this.tutorialSteps[this.currentTutorialStepIndex];
    if (step.element) {
      setTimeout(() => {
        document.getElementById(step.element!)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }

  copyGameFolderLinkToClipboard(event: any) {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(`%userprofile%\\Documents\\My Games\\${this.gameName}`);
  }

  enableQuickFiltersAsMainTab(): void {
    this.settings.setQuickFiltersAsMainTab(true);
    this.dismissQuickFiltersMainTabBanner();
  }

  dismissQuickFiltersMainTabBanner(): void {
    this.settings.dismissQuickFiltersMainTabBanner();
    this.showQuickFiltersMainTabBanner = false;
  }
}
